/**
 * Warnings "Invalid prop `value` supplied to `Select`" in console are because of:
 * https://github.com/mui-org/material-ui/issues/10845
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';

const styles = theme => ({
  formControl: {
    width: '100%'
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing(0.25),
  },
});

class MultipleSelect extends React.Component {
  state = {
    selectedItemsInitialState: []
  };

  handleChange = (event, input) => {
    input.onChange(event.target.value);
  };

  componentDidMount() {
    this.setState({
      selectedItemsInitialState: this.props.input.value,
    });
  }

  render() {
    const { classes, theme, input, label, meta: { touched, error }, options, disableSelected = true, ...custom } = this.props;
    return (
      <FormControl className={classes.formControl}>
        <InputLabel>{label}</InputLabel>
        <Select
          multiple
          {...input}
          onChange={event => {
            this.handleChange(event, input);
          }}
          renderValue={selected => (
            <div className={classes.chips}>
              {selected.map(value => (
                <Chip key={value.id} label={value.name} className={classes.chip} />
              ))}
            </div>
          )}

          // TODO: Not sure what for this one is
          error={!!(touched && error)}
          {...custom}
        >
          {options.map(option => (
            <MenuItem key={option.id}
              value={option}
              disabled={disableSelected && this.state.selectedItemsInitialState.findIndex(selected => selected.id === option.id) > -1}>
              <Checkbox checked={input.value.findIndex(selected => selected.id === option.id) > -1} />
              <ListItemText primary={option.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
}

MultipleSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(MultipleSelect);
